<template>
  <dashboard-component/>
</template>

<script>
import DashboardComponent from '@/spa/components/board/dashboard/Dashboard';

export default {
  name: 'DashboardPage',
  components: {
    DashboardComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/DashboardPage.vue